module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-manifest@5.16.0_@types+node@24.10.1_gatsby@5.16.1_@types+node@24.10.1_bab_e938c9a13ea0f78b3545736d5ed2fed6/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"/home/runner/work/Acquisition.Web.Pulse/Acquisition.Web.Pulse/static/favicon-pulse.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"060ff74fc3e0c074d63f9b2e9b1556d0"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.16.1_@types+node@24.10.1_babel-eslint@10.1.0_eslint@10.9.1__esbuild@0.25.12_re_b454af39c76d8bcab4bd2918e8c4ff5a/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
